import { Route } from '@angular/router';

import { SignInPageComponent } from './pages/sign-in/sign-in.component';

export const AUTH_ROUTES: Route[] = [
  {
    path: 'sign-in',
    component: SignInPageComponent,
  },
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full',
  },
];
